module.exports = __webpack_public_path__ + "common/sidebar/icon-search-0644200d08002786a5f93db7cb28b07f.svg";